
import Vue from "vue";

export default Vue.extend({
  name: "LargeSelect",
  props: {
    title: {
      type: String,
      default: "",
    },
    labelInput: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    errors: {
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
      default: 0,
    },
    model: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOpen: false,
      innerModel: this.model,
    };
  },
  methods: {
    updateOption() {
      this.$emit("updateOption", { index: this.index, val: this.innerModel });
    },
  },
});
